const styles = `:host {
  font: var(--goto-body-small);
  color: var(--goto-text-04);
  box-sizing: border-box;
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  position: relative;
  --goto-icon-size: 18px;
  --goto-icon-color: var(--goto-text-04);
}
:host chameleon-icon-button {
  display: inline-flex;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  --goto-icon-button-icon-color: var(--goto-text-07);
}

::slotted(p) {
  margin: 0;
}

:host([variant=info]) {
  background-color: var(--goto-interactive-01);
}

:host([variant=success]) {
  background-color: var(--goto-success-01);
}

:host([variant=danger]) {
  background-color: var(--goto-danger-01);
}

:host([variant=dark]) {
  background-color: var(--goto-neutral);
}

::slotted(a[slot=action]),
::slotted(chameleon-link[slot=action]) {
  font: var(--goto-body-small);
  color: var(--goto-text-04);
  text-decoration: underline;
  cursor: pointer;
  --goto-link-color: var(--goto-text-04);
  --goto-link-text-decoration: underline;
}`; export default styles;